// extracted by mini-css-extract-plugin
export default {"header":"style_header__CAk1E","footer":"style_footer__84m+E","social-link":"style_social-link__cl7-g","social-links-container":"style_social-links-container__NOgfV"};